export function useURLSafeString(value: string) {
  return useKebabCase(value?.normalize('NFKD')?.replace(/[^\w\s-]/g, '')
    ?.replace(/[&\/\\#,+()$~%.'":*?!<>{}]/g, ''))
}
